import { useEffect } from "react";
import { useT } from "@sablier/v2-locales";
import { _ } from "@sablier/v2-mixins";
import { useRouter } from "next/router";

export default function useNextRouterConfirm(isEnabled: boolean) {
  const router = useRouter();
  const { t } = useT();

  useEffect(() => {
    if (_.isWindow()) {
      const warningText = t("structs.leavePage");

      const handleBrowseAway = () => {
        if (!isEnabled) {
          return;
        }

        if (window.confirm(warningText)) {
          return;
        }
        router.events.emit("routeChangeError");
        /**
         * As per https://github.com/vercel/next.js/discussions/32231 we need to throw a fake error to stop the router
         * Keep this as a text-only throw (doing it with a proper Error will alert the browser)
         */
        throw t("structs.routeChangeAborted");
      };

      /** https://nextjs.org/docs/pages/api-reference/functions/use-router#routerevents */
      router.events.on("routeChangeStart", handleBrowseAway);

      return () => {
        router.events.off("routeChangeStart", handleBrowseAway);
      };
    }
  }, [router.events, isEnabled, t]);
}
